import { FC } from 'react';
import { useTranslation } from 'next-i18next';

import { personalIdentifiersI18nMap } from '@/entities/personalIdentifiers';
import { BreadcrumbItem } from '@/shared/components/breadcrumb';
import { PageHeader } from '@/shared/components/layout/PageHeader';
import { routes } from '@/shared/helpers';
import { PersonalIdentifierType } from '@/shared/lib/sj-orm/models/personalIdentifiersDocuments/types';
import { Button } from '@/shared/uikit/Button';

type PersonalIdentifierFormHeaderProps = {
  title: string;
  category: PersonalIdentifierType;
  isSubmitting: boolean;
  onCancel: () => void;
};

export const PersonalIdentifierFormHeader: FC<PersonalIdentifierFormHeaderProps> = ({
  title,
  category,
  isSubmitting,
  onCancel,
}) => {
  const { t: tc } = useTranslation('common');
  const { t: tp } = useTranslation('entities/personalIdentifiers', { keyPrefix: 'types' });

  const breadcrumbs: BreadcrumbItem[] = [
    { title: tc('navigation.personalIdentifiers'), href: routes.personalIds() },
    { title },
  ];

  return (
    <PageHeader
      title={`${title} – ${tp(personalIdentifiersI18nMap[category])}`}
      breadcrumbs={breadcrumbs}
    >
      <Button type="default" onClick={onCancel} htmlType="button" style={{ height: 44 }}>
        {tc('cancel')}
      </Button>
      <Button style={{ height: 44 }} htmlType="submit" loading={isSubmitting}>
        {tc('save')}
      </Button>
    </PageHeader>
  );
};
